export class IFrameProtocol {
    constructor(iframe, origin) {
        // React to messages from any iframe
        this.globalListeners = {};
        this.globalListenersCount = 0;
        // React to messages from the iframe owned by this instance
        this.channelListeners = {};
        this.channelListenersCount = 0;
        // Random number to identify this instance of the client when messages are coming from multiple iframes
        this.channelId = Math.floor(Math.random() * 1000000);
        this.frameWindow = iframe.contentWindow;
        this.origin = origin;
        this.globalListeners = [];
        this.channelListeners = [];
        this.eventListener = this.eventListener.bind(this);
        if (typeof window !== "undefined") {
            window.addEventListener("message", this.eventListener);
        }
    }
    cleanup() {
        window.removeEventListener("message", this.eventListener);
        this.globalListeners = {};
        this.channelListeners = {};
        this.globalListenersCount = 0;
        this.channelListenersCount = 0;
    }
    // Sends the channelId and triggers an iframeHandshake promise to resolve,
    // so the iframe can start listening for messages (based on the id)
    register() {
        if (!this.frameWindow) {
            return;
        }
        this.frameWindow.postMessage({
            type: "register-frame",
            origin: document.location.origin,
            id: this.channelId,
        }, this.origin);
    }
    // Messages are dispatched from the client directly to the instance iframe
    dispatch(message) {
        if (!this.frameWindow) {
            return;
        }
        this.frameWindow.postMessage({
            $id: this.channelId,
            codesandbox: true,
            ...message,
        }, this.origin);
    }
    // Add a listener that is called on any message coming from an iframe in the page
    // This is needed for the `initialize` message which comes without a channelId
    globalListen(listener) {
        if (typeof listener !== "function") {
            return () => {
                return;
            };
        }
        const listenerId = this.globalListenersCount;
        this.globalListeners[listenerId] = listener;
        this.globalListenersCount++;
        return () => {
            delete this.globalListeners[listenerId];
        };
    }
    // Add a listener that is called on any message coming from an iframe with the instance channelId
    // All other messages (eg: from other iframes) are ignored
    channelListen(listener) {
        if (typeof listener !== "function") {
            return () => {
                return;
            };
        }
        const listenerId = this.channelListenersCount;
        this.channelListeners[listenerId] = listener;
        this.channelListenersCount++;
        return () => {
            delete this.channelListeners[listenerId];
        };
    }
    // Handles message windows coming from iframes
    eventListener(message) {
        if (!message.data.codesandbox) {
            return;
        }
        Object.values(this.globalListeners).forEach((listener) => listener(message.data));
        if (message.data.$id !== this.channelId) {
            return;
        }
        Object.values(this.channelListeners).forEach((listener) => listener(message.data));
    }
}
//# sourceMappingURL=iframe-protocol.js.map